import { createAction, props } from '@ngrx/store';
import { DocumentType } from 'app/models/document';

export const documentTypesFetched = createAction('DOCUMENT_TYPES_FETCHED', props<{ documentTypes: DocumentType[] }>());

